import React from 'react';

/** @param {React.ComponentProps<'svg'>} props */
export const SellerNavIconOverview = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const SellerNavIconListings = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SellerNavIconOrders = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M5 8h14l-1 12H6L5 8Zm2-3h10v3H7V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const SellerNavIconMessages = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M5 6h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-4l-4 3v-3H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

/** Heart icon for wishlist hub navigation. */
export const SellerNavIconWishlist = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SellerNavIconWallet = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M16 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const SellerNavIconSettings = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SellerNavIconLogout = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M10 17H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4M14 12h7m0 0-3-3m3 3-3 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Primary seller hub navigation (dashboard sidebar + global mobile drawer for sellers). */
export const SELLER_NAV_ITEMS = [
  {
    routeName: 'SellerDashboardPage',
    params: {},
    messageId: 'SellerDashboard.nav.overview',
    Icon: SellerNavIconOverview,
  },
  {
    routeName: 'ManageListingsPage',
    params: {},
    messageId: 'SellerDashboard.nav.listings',
    Icon: SellerNavIconListings,
  },
  {
    routeName: 'InboxPage',
    params: { tab: 'orders' },
    messageId: 'SellerDashboard.nav.orders',
    Icon: SellerNavIconOrders,
  },
  {
    routeName: 'InboxPage',
    params: { tab: 'sales' },
    messageId: 'SellerDashboard.nav.messages',
    Icon: SellerNavIconMessages,
  },
  {
    routeName: 'WishlistPage',
    params: {},
    messageId: 'SellerDashboard.nav.wishlist',
    Icon: SellerNavIconWishlist,
  },
  // {
  //   routeName: 'StripePayoutPage',
  //   params: {},
  //   messageId: 'SellerDashboard.nav.wallet',
  //   Icon: SellerNavIconWallet,
  // },
  {
    routeName: 'ContactDetailsPage',
    params: {},
    messageId: 'SellerDashboard.nav.settings',
    Icon: SellerNavIconSettings,
  },
];

/** Main seller links only (excluding the Settings parent — account links are nested under it). */
export const SELLER_DASHBOARD_MAIN_NAV_ITEMS = SELLER_NAV_ITEMS.filter(
  item => item.routeName !== 'ContactDetailsPage'
);

/** Settings header in the sidebar; account routes render nested beneath. */
export const SELLER_SETTINGS_NAV_PARENT = SELLER_NAV_ITEMS.find(
  item => item.routeName === 'ContactDetailsPage'
);
